<template>
    <div v-if="certify">
        <div v-if="isOfflineWarning(certify) && isNotDownload" class="w3-center w3-padding">
            <span class="w3-text-red">
                Figyelem! Az útvonal adatai nincsenek letöltve az eszközre, így offline állapotban nem teljesíthető!
                <br>Kérjük, kapcsolja be az internet elérést, hogy a szükséges adatok le tudjanak töltődni készülékére!
            </span>
        </div>
        <div v-if="isCertifyUploadWarning(certify)" class="w3-center w3-padding">
            <span class="w3-text-red">
                Figyelem! A teljesítési adatok feltöltésére még nem került sor!
            </span>
        </div>
        <div v-if="geogo">
            <div class="w3-padding uppercase w3-green">Teljesítés adatlapja</div>
            <div class="w3-row w3-padding">
                <div class="route-title">
                    {{certify.hikeName}}
                </div>
            </div>
            <div class="w3-margin-bottom">
                <table class="w3-table w3-bordered w3-border-top w3-light-grey"> 
                    <tr>
                        <td>Teljesítés állapota:</td>
                        <td>
                            <font-awesome-icon class="w3-text-green" v-if="certify.status==2" icon="check-circle"></font-awesome-icon>
                            <font-awesome-icon class="w3-text-red" v-if="certify.status==3" icon="times-circle"></font-awesome-icon>
                            <font-awesome-icon class="w3-text-blue" v-if="certify.status==1" icon="history"></font-awesome-icon>
                            <font-awesome-icon class="w3-text-black" v-if="certify.status==0" icon="angle-double-right"></font-awesome-icon>
                            {{certify.status | filterNumberToStatus}}
                        </td>
                    </tr>
                    <tr>       
                        <td>Rajt idő:</td><td>{{certify.startdate | filterDateTimeFormat}}</td>        
                    </tr>
                    <tr v-if="certify.status>1">    
                        <td>Cél idő:</td><td>{{certify.enddate | filterDateTimeFormat}}</td>        
                    </tr>    
                    <tr v-if="certify.status<2">            
                        <td>Felhasznált idő:</td><td>{{usedTime | filterNumberToTime}}</td>        
                    </tr>    
                    <tr v-if="certify.status<2">
                        <td>Hátralévő idő:</td><td>{{remainingTime | filterNumberToTime}}</td> 
                    </tr>                    
                    <tr>            
                        <td>Megtett táv/szint:</td><td>{{sumDistance | filterFloatRound}} km / {{sumLevelUp}} m</td>        
                    </tr>  
                    <tr v-if="certify.status<2">            
                        <td>Hátralévő táv/szint:</td><td>{{remainingDistance | filterFloatRound}} km / {{remainingLevelUp}} m</td>        
                    </tr> 
                    <tr v-if="certify.status<2 && estimatedTargetTime">
                        <td>Várható célidő:</td><td v-if="certify.sumtime>0">{{estimatedTargetTime | filterDateTimeFormat}}</td>
                    </tr>                                        
                    <tr v-if="certify.status>1">
                        <td>Teljesítés idő:</td><td>{{certify.sumtime | filterNumberToTime}}</td>
                    </tr>
                    <tr v-if="avgSpeed">
                        <td>Átlagsebesség:</td><td>{{avgSpeed | filterFloatRound}} km/h</td>
                    </tr>  
                </table>    
            </div>
            <div class="w3-bar" v-for="(item, index) in orderedList" :key="index">
                <div class="w3-bar-item w3-padding" >{{item.name}}</div>
                <div v-if="getCertifyTime(item.id)==0 && certify.status<2" class="">
                    <div v-if="showCertifyLink(item)" v-on:click="startCertify(item)" class="cursorpointer w3-button w3-right w3-border w3-border-green w3-hover-white w3-green w3-padding">IGAZOLÁS</div>
                </div> 
                <div v-if="getCertifyTime(item.id)>0" class="w3-bar-item w3-right w3-text-green" >
                    <font-awesome-icon icon="check-circle"></font-awesome-icon>
                </div>
                <div v-if="getCertifyTime(item.id)==0 && certify.status==3" class="w3-bar-item w3-right w3-text-red" ><font-awesome-icon icon="times-circle"></font-awesome-icon></div>
                <div v-if="getCertifyTime(item.id)!=0" class="w3-bar-item w3-right">{{getCertifyTime(item.id) | filterTimeFormat}}</div>            
            </div>
            <div v-if="certify.status==1" >
                <hr>
                <div class="w3-margin w3-center">
                    <button class="w3-button w3-red w3-border w3-border-red w3-hover-white" v-on:click="endCertifyClick">Teljesítés befejezése</button>            
                </div>
            </div>    
        </div>
    </div>    
</template>

<script>
import "../filters.js"
import {store} from "../store.js";
const fb = require('../firebase.js');
export default {
    name: 'Certify',
    data() {
        return {
            isNotDownload:true,
            certify: null,
            hikePoints: null,
            geogo:null,
            now: null,
            usedTime: null,
            remainingTime:null,
            remainingPoint:null,
            certPoint:null,
            item:null,
            orderedList:null,
            sumDistance:0,
            sumLevelUp:0,
            remainingDistance:null,
            remainingLevelUp:null,
            avgSpeed:null,
            estimatedTargetTime:null,
        }
    },    
    computed: {
    },       
    methods:{
        getPointId(ordernum){
            for (var i in this.hikePoints) {
                if (this.hikePoints[i].ordernum==ordernum) return i;
            }
            return '';
        },
        showCertifyLink(item){
            var out=false;
            var prevPointId='';
            if (item.ordernum-1>0) {
                prevPointId=this.getPointId(item.ordernum-1);
                if (this.certify.points[prevPointId]>0) out=true;
            } else out=true;
            return out;
        },
        isCertifyUploadWarning(item){
            return (this.$storage.get('uploadCertifyList', []).indexOf(item.id)>-1); 
        },  
        getSumData(pList,certify){
            var out={
                "sumdistance":0,
                "sumlevelup":0
            }    
            for (var i=0; i<pList.length; i++ ){
                if (certify.points[pList[i].id]!="0") {
                    out.sumdistance+=pList[i].prevDist;
                    out.sumlevelup+=pList[i].prevLevel;
                }                
            }
            return out;
        },
        myOrder(hikePoints,certify){
            hikePoints=_.orderBy(hikePoints, 'ordernum', 'asc');
            var pList=[];   
            for (var i in hikePoints) {
                pList.push(hikePoints[i]);
            }              
            var sdata=this.getSumData(pList,certify);            
            this.sumDistance=sdata.sumdistance;
            this.sumLevelUp=sdata.sumlevelup;
            this.remainingDistance=this.geogo.distance-this.sumDistance;
            this.remainingLevelUp=this.geogo.level-this.sumLevelUp;
            if (this.certify.sumtime>0) {
                this.avgSpeed=this.sumDistance/(this.certify.sumtime/3600);
                var now=Math.floor(Date.now());
                this.estimatedTargetTime=this.certify.startdate+this.remainingDistance/this.avgSpeed*3600*1000+this.certify.sumtime*1000;
            }            
            if (this.certify.status==2){
                this.sumDistance=this.geogo.distance;
                this.sumLevelUp=this.geogo.level;
                this.avgSpeed=this.sumDistance/(this.certify.sumtime/3600);
            }            
            return pList;
        },
        isOfflineWarning(item){
            if (item.status>1) return false;
            else return !(this.$storage.has('ggData2-'+item.hikeId)); 
        },  
        startCertify(item){
            this.item=item;
            this.$router.push({
                name: 'mainmap', 
                params: { source: 'certify-point', point: item}
            });
        },                       
        setTimes(){
            if (this.geogo) {
                this.now=Math.floor(Date.now());
                if (this.certify.startdate) this.usedTime=parseInt((this.now-this.certify.startdate)/1000,10);
                else this.usedTime=0;
                var rt=this.geogo.timeTour*3600-this.usedTime;
                if (rt>0) this.remainingTime=rt;
                else this.remainingTime=0;
            }
        },
        getCertifyTime(pid) {
            return this.certify.points[pid];
        },
        endTest(){
            try{
                var endT=true;
                for(var p in this.certify.points){
                    if (this.certify.points[p]=="0") endT=false;
                }  
                if (endT) {
                    if (this.geogo.message) {
                        let self = this;
                        this.$dialog.alert(this.$setDialogMsg('w3-blue',this.certify.hikeName + " - Üzenet",this.geogo.message))
                        .then(function(){
                            self.endCertify();
                        });
                    } else {
                        this.endCertify();         
                    }    
                }
            }catch(e){
                console.log(e);
            }
        },
        endCertifyClick(){
            let self = this;
            this.$dialog.confirm(this.$setDialogMsg('w3-yellow','Figyelmeztetés','Biztosan befejezed a túra teljesítését?<br>Ha még nem igazoltál minden ellenőrzőponton, akkor a teljesítés sikertelen lesz.'))
            .then(function(dialog) {
                self.endCertify();
            }); 
        },
        setCertifymode(geogo,time){
            if (geogo.mode==2) return this.$appData.certModeName[3];
            else {
                if (time<=geogo.timeRun*3600) return this.$appData.certModeName[2];
                else if (time<=geogo.timeHike*3600) return this.$appData.certModeName[1];
                else return this.$appData.certModeName[0];
            }
        },
        endCertify(){
            try {
                if (this.$isCertify(this.certify,this.geogo)) {
                    this.certify.status=2;
                    this.certify.ggpoint=this.geogo.ggpoint;
                    this.certify.mode=this.setCertifymode(this.geogo,this.certify.sumtime);
                } else {
                    this.certify.status=3;
                    this.certify.ggpoint=0;
                    this.certify.mode="";
                }
                this.saveCertify();
            }catch(e){
                console.log(e);
            }
        },
        saveCertify(){
            try{
                this.$storage.set('actualCertify', this.certify); 
                var favoriteList = this.$storage.get('favoriteList', []);
                for (var f in favoriteList) {
                    if (f==this.certify.id) favoriteList[f]=this.certify;
                }
                this.$storage.set('favoriteList', favoriteList);                 
                if (this.isOnline) {
                    this.$showSpinner();
                    fb.UpdateCertify(this.certify).then(res=>{  
                        this.$hideSpinner(); 
                        if (this.certify.status==2)
                            this.$dialog.alert(this.$setDialogMsg('w3-blue',this.certify.hikeName,"<span class='w3-text-green w3-large'>Sikeres teljesítés!</span><br>A teljesítés mentése megtörtént!"))
                            .then(r=>{
                                this.$router.push({name:'displaycertify', params: { cert: this.certify } });    
                            });
                        if (this.certify.status==3)
                            this.$dialog.alert(this.$setDialogMsg('w3-blue',this.certify.hikeName,"<span class='w3-text-red w3-large'>Sikertelen teljesítés!</span><br>A teljesítés mentése megtörtént!"))
                            .then(r=>{
                                this.$router.push({name:'displaycertify', params: { cert: this.certify } });    
                            });
                    }).catch(e=>{
                        console.log(e);
                        var uploadCertifyList = this.$storage.get('uploadCertifyList', []);              
                        if (!uploadCertifyList.includes(this.certify.id)) uploadCertifyList.push(this.certify.id);
                        this.$storage.set('uploadCertifyList', uploadCertifyList);                                 
                        this.$hideSpinner(); 
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Teljesítés mentése','Hiba történt az adatok feltöltése során.'));
                    })
                } else {
                    var uploadCertifyList = this.$storage.get('uploadCertifyList', []);              
                    if (!uploadCertifyList.includes(this.certify.id)) uploadCertifyList.push(this.certify.id);
                    this.$storage.set('uploadCertifyList', uploadCertifyList);                                 
                    this.$dialog.alert(this.$setDialogMsg('w3-yellow',this.certify.hikeName,"A teljesítés mentése offline állapot miatt csak az eszközön történt meg!"));                                        
                    this.orderedList=this.myOrder(this.hikePoints,this.certify);
                }
            }catch(e){
                console.log(e);
            }
        }
    },
    timers: {
      setTimes: { time: 1000, autostart: true, repeat: true }
    },
    created: function(){     
    }, 
    mounted(){
        try{
            this.$showSpinner();    
            this.certify=this.$storage.get('actualCertify', null);
            var storageId='ggData2-'+this.certify.hikeId;
            var ggData=this.$storage.get(storageId, false);      
            if (ggData) {
                this.geogo=ggData.geogo;
                this.hikePoints=ggData.points;
                this.orderedList=this.myOrder(this.hikePoints,this.certify);
                if (ggData.track) this.$storage.set('actualTrack', ggData.track);
                else this.$storage.set('actualTrack', null);
                this.$hideSpinner();
                this.endTest();
            } else {
                fb.GetGeogo(this.certify.hikeId).then(r=>{
                    this.geogo=r;
                    fb.Download(this.geogo.id,this.geogo.track,this.geogo.name,this.geogo)
                    .then(res=>{
                        var storageId='ggData2-'+this.geogo.id; 
                        this.$storage.set(storageId, res); 
                        ggData=res;
                        this.hikePoints=ggData.points;
                        this.orderedList=this.myOrder(this.hikePoints,this.certify);
                        if (ggData.track) this.$storage.set('actualTrack', ggData.track);
                        else this.$storage.set('actualTrack', null);
                        this.$hideSpinner();
                        this.isNotDownload=false;
                        this.endTest();
                    }).catch(e=>{
                        console.log(e);
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok letöltése során.'));
                    }) 
                }).catch(e=>{
                    console.log(e);
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az útvonaladatok letöltése során.<br>Az adatok letöltéséhez internet kapcsolat szükséges!'));
                })       
            }
        }catch(e){
            console.log(e);
        }
    }
}
</script>

